export function LinkIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.667 2.5H17.5V8.333"
        stroke="#3C91E6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.167 10.833L17.5 2.5"
        stroke="#3C91E6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 11.667V15C15 16.381 13.881 17.5 12.5 17.5H5C3.619 17.5 2.5 16.381 2.5 15V7.5C2.5 6.119 3.619 5 5 5H8.333"
        stroke="#3C91E6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
